export default __webpack_public_path__ + "static/media/date.b7493425.svg";